import { isSiteCanadian } from './helpers';
import { useLocalization } from 'src/utils/useLocalization';

const formatToUSDate = (date: string) => {
    return new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(date));
};

const formatToCanadianDate = (date: string) => {
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(date));
};

export const formatDate = (date: string) => {
    return isSiteCanadian() ? formatToCanadianDate(date) : formatToUSDate(date);
};

export const formatDateAndTime = (date: string) => {
    const { fundingStatusDetails } = useLocalization();
    if (!date) return '';

    const formattedDate = formatDate(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: !isSiteCanadian(),
        timeZoneName: 'shortGeneric',
    }).format(new Date(date));
    return `${formattedDate} ${fundingStatusDetails.DATE_AT} ${formattedTime}`;
};

export const formatDateYMD = (date: Date) => {
    const dateOffset = 1;
    const twoDigits = 2;
    const newDate = new Date(date);
    let month: string | number = (newDate.getMonth() + dateOffset).toString();
    let day: string | number = newDate.getDate().toString();
    const year = newDate.getFullYear().toString();

    if (month.length < twoDigits) {
        month = `0${month}`;
    }
    if (day.length < twoDigits) {
        day = `0${day}`;
    }
    return `${year}-${month}-${day}`;
};
